import React, { useState, useEffect } from 'react';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/login/login";
import Home from "../pages/home/home";
import UserList from "../pages/users/userList";
import Header from '../component/header';
import SideBar from '../pages/home/component/sidebar'
import { HomeBanner } from '../component/banner'
import DashBoard from '../pages/home/component/dasboard';
import OrderList from '../pages/orders/orderList';
import ProductList from '../pages/products/productList';
import Catalogue from '../pages/products/catalogue'
import MemberList from '../pages/members/memberList';
import OfferPage from '../pages/offers/offerPage';
import NotificationManager from '../pages/notification/notificationManager';
import RefundList from '../pages/refund/refundList';
import { Commet } from 'react-loading-indicators';



import AuthHandler from './AuthHandler'; // adjust the path as needed
import VendorProductEntry from '../pages/BulkProduct/vendorProductEntry';

function Router() {
  const [user, setUser] = useState();
  const [selectedPage, setSelectedPage] = useState('dashboard');
  const [loading, setLoading] = useState(false);

  const handlePageSelect = (page) => setSelectedPage(page);

  const UnAuthorizedEntry = () => (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }}>
      <h1>You are not authorized</h1>
    </div>
  );

  return (
    <BrowserRouter>
      <AuthHandler setUser={setUser} setLoading={setLoading} />
      {user && (
        <>
          <HomeBanner user={user} />
          <SideBar onSelect={handlePageSelect} selectedPage={selectedPage} user={user} />
        </>
      )}
      <div className={user ? 'main_container' : ''}>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }}>
            <Commet color="#4154f1" size="medium" />
          </div>
        ) : (
          <Routes>
            <Route path="/" element={user ? <DashBoard user={user} /> : <Login />} />
            <Route path="/home" element={user ? <DashBoard user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/register" element={user ? <UserList user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/dashboard" element={user ? <DashBoard user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/catalogue" element={user ? <Catalogue user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/productList" element={user ? <ProductList user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/bulkProductEntry" element={user ? <VendorProductEntry user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/orders" element={user ? <OrderList user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/member" element={user ? <MemberList user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/offers" element={user ? <OfferPage user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/notifications" element={user ? <NotificationManager user={user} /> : <UnAuthorizedEntry />} />
            <Route path="/refund" element={user ? <RefundList user={user} /> : <UnAuthorizedEntry />} />
            <Route path="*" element={<h1>Page not found</h1>} />
          </Routes>
        )}
      </div>
    </BrowserRouter>
  );
}

export default Router;


